export const Endpoints = {
  sendEmailApi: 'v1/email/emailnotification',
  saveEndUserApi: 'v1/email/useremailinvitees',
  saveContractAdminApi: 'v1/account/contract/contract-admin',
  deleteContractAdminApi: 'v1/account/contract/contract-admin/remove',
  accountApi: 'v1/account',
  userRegistrationAccountApi: 'v1/user-registration/account',
  userRegistrationLocationApi: 'v1/user-registration/location',
  userRegistrationUserGroupEntitlementsApi:
    'v1/user-registration/user-group/entitlement',
  emailDomainApi: 'v1/account/email-domain',
  welcomeEmailApi: 'v1/account/welcome-email',
  userApi: 'v1/account/user',
  userReportApi: 'v1/account/user/report',
  userExportApi: 'v1/account/user/export',
  addedCriteriaDdDetailsApi:
    'v1/account/user/entitlement/addedCriteriaDdDetails',
  apiRequestRapidApi: 'rapid/sfs/v1/api-request',
  userRegistrationUserPostApi: 'v1/user-registration',
  bulkUserEntitlementApi: 'v1/account/user/bulk-user-entitlement',
  userGroupApi: 'v1/account/user-group',
  configurationApi: 'v1/configuration',
  userRegistrationConfigurationApi: 'v1/user-registration/configuration',
  packagesApi: 'v1/package',
  userentitlementsApi: 'v1/account/user/entitlement',
  bulkDeleteUserEntitlementsApi: 'v1/account/user/entitlement/bulk-delete',
  userEntitlementsAuditApi: 'v1/account/user/entitlement-audit',
  bulkGetUserEntitlementsAuditApi:
    'v1/account/user/entitlement-audit/get-entitlement-audit',
  userEntitlementsAuditExportApi: 'v1/account/user/entitlement-audit/export',
  packageDataset: 'v1/package/dataset',
  locationApi: 'v1/account/location',
  addressValidatorApi: 'v1/account/location/address-validate',
  duplicateAddressValidatorApi:
    'v1/account/location/duplicate-address-validate',
  contractApi: 'v1/account/contract',
  offboardContractApi: 'v1/account/contract/offboard',
  onboardContractApi: 'v1/account/contract/onboard',
  virtualContractApi: 'v1/account/contract/virtual-contract',
  virtualContractDeleteApi: 'v1/account/contract/virtual-contract/delete',
  contractPackagesApi: 'v1/account/contract/package',
  contractProductsApi: 'v1/account/contract/product',
  bulkUploadTemplateApi: 'v1/account/bulk-upload-template',
  userEntitlementsCloneApi: 'v1/account/user/entitlement/clone',
  distributorUserApi: 'v1/account/distributor/user',
  bulkDistributorUserApi: 'v1/account/distributor/user/bulk/get-user-ids',
  distributorApi: 'v1/package/distributor',
  userGroupEntitlementsApi: 'v1/account/user-group/entitlement',
  userGroupContactApi: 'v1/account/user-group/contact',
  userPreferenceApi: 'v1/account/user/user-preference',
  userRegistrationUserGroupContactApi:
    'v1/user-registration/user-group/contact',
  entitlementExportApi: 'v1/account/user/entitlement/export',
  entitlementExportReportApi: 'v1/account/user/entitlement/export-report',
  entitlementExportCSVApi: 'v1/account/user/entitlement/export-api',
  entitlementReportApi: 'v1/account/user/entitlement/report',
  deleteEndpoint: '/remove',
  apiRequestApi: 'v1/api-request',
  // Analytics Endpoints
  analyticsEntitlementAuditApi: 'rapid/sfs/v1/analytics-entitlement-audit', // RAPID endpoint
  analyticsContactAuditApi: 'rapid/sfs/v1/analytics-contact-audit', // RAPID endpoint
  contractDistributorApi: 'rapid/sfs/v1/contract-distributor', // RAPID endpoint
  companyDistributorMappingApi: 'rapid/sfs/v1/company-distributor-mapping', // RAPID endpoint
  companyDistributorMappingSaveApi:
    'rapid/sfs/v1/company-distributor-mapping/save', // RAPID endpoint
  salesforceEntitlementApi: 'rapid/sfs/v1/salesforce-entitlement', // RAPID endpoint
  getOldLocationsApi: 'rapid/sfs/v1/previous-mapped-locations', // RAPID endpoint
  updateLocationMappingApi: 'rapid/sfs/v1/user-location-mapping', // RAPID endpoint
};

export const packageDatasetProps = [
  'marketplaceLongDescription',
  'industryCoverageData',
  'marketplaceShortDescription',
  'marketplaceDatasetName',
  'keyFeatures',
  'keyServiceHighlights',
  'keyMarkets',
  'keyMarketInsightHighlights',
  'keyMarketInsights',
  'keyHighlights',
  'keyPersonasUseCases',
  'keyAssessments',
  'keyPriceAssessments',
  'keyBenefits',
  'marketsCovered',
];

export const distributorDatasetProps = [
  'tile_main_heading',
  'tile_description',
  'distributorDescription',
  'distributorDisplayName',
  'distributorPlatformDisplayName',
  'keyUseCases',
  'keyFeatures',
  'keyWorkflows',
  'keyBenefits',
  'keyPersonas',
  'keyCapabilities',
  'features',
  'accessibleData',
  'delivery',
  'coverage',
  'platformDescription',
  'distributorPlatformLink',
  'platformUserPersona',
  'commodityCoverage',
  'csmMarketDataPackageCoverage',
  'csmMarketInsightsPackageCoverage',
  'csmRiskInsightsPackageCoverage',
];

export const setUserId = (newUserId) => {
  UserId = newUserId;
};

export const endUserGroup = 'SFS_ENDUSER';
export const ccaUserGroup = 'SFS_CCA';
export const csaUserGroup = 'GRP_SFS_CSA';
export const viewerUserGroup = 'GRP_SFS_VIEWER';
export const exhibitUserGroup = 'SFS_EXHIBIT';
export const superUserGroup = 'GRP_SFS_SUPER_USERS';

export let UserId = '';
export const contractType = ['CSM+', 'CSM1.0', 'Market Basics'];
export const contractTypeCSMPlus = 'CSM+';
export const contractTypePrimary = 'Market Basics';
export const contractDisplayOptionKey = 'DISPLAY_CONTRACT';
export const columnDisplayOptionKey = 'COLUMN_OPTION_PREFERENCES';

export const ProductDeliveryPlatforms = ['AlphaMail'];
export const ProductTypes = ['Ancillary', 'Legacy Product'];
export const AutoSelectPkgDist = {
  Market_Basics: {
    pkgName: 'Market Basics',
    distName: 'SPGCI:Core:Web', // reference only, not used in logic
    distId: '46',
    distPlatform: 'Platts Platform', // reference only, not used in logic
  },
};

export const userPreferencesKey = { displayContract: 'DISPLAY_CONTRACT' };

export const GenericName = {
  channelPartners: 'Channel Partners',
  spGlobalEnergy: 'S&P Global Energy',
};

export const UserGroupTab = 'user-group-tab';
export const entitlementTabName = 'entitlements-tab';
export const productEntitlementTabName = 'product-entitlements-tab';
export const manageUsersTabName = 'manage-user-tab';

export const deliveryType = ['Channel'];
export const RequiredPlatformCategory = [GenericName.channelPartners];

export const setGlobalUserType = (isUserCCA) => {
  isCCA = isUserCCA;
};

export let isCCA = false;

export const setMaxExportSizeLimit = (limit) => {
  maxExportSizeLimit = limit;
  Verbiage.entitlementExportExceedMsg = `Number of records selected for export is greater than allowed limit of ${limit}. Reduce the number of records by updating the criteria.`;
};

export const setMaxContractLimit = (limit) => {
  maxContractLimit = limit;
};

export const maxPageSize = 50000;
export let maxExportSizeLimit = null;
export let maxContractLimit = 300;

// Entitlement Status
export const PendingActive = 'Pending Active';
export const Active = 'Active';
export const PendingApproval = 'Pending Approval';
export const PendingInactive = 'Pending Inactive';
export const Cancelled = 'Cancelled';
export const Rejected = 'Rejected';
export const Blocked = 'Blocked';
export const Draft = 'Draft';
// FEATURE DISABLED (Release july-2026) - removed Draft from positiveStatuses
// export const positiveStatuses = [Active, PendingActive, Draft];
export const positiveStatuses = [Active, PendingActive];
export const negativeStatuses = [Cancelled, Rejected, PendingInactive, Blocked];

// Contract Status
export const Inactive = 'Inactive';
export const Suspended = 'Suspended';

// Bulk Upload Template Type
export const BulkUploadUsersTemplateType = 'BulkUploadUsers';
export const BulkUploadUserEntitlementsTemplateType =
  'BulkUploadUserEntitlements';

export const UrlPath = {
  users: '/users',
  packages: '/packages',
  entitlements: '/entitlements',
  contact: 'https://www.spglobal.com/commodity-insights/en/contact',
  contactCI:
    'https://www.spglobal.com/commodity-insights/en/overview/contact/contact-us',
  termsOfUse: 'https://www.spglobal.com/en/terms-of-use',
  privacy: 'https://www.spglobal.com/en/privacy',
  cookieNotice:
    'https://www.spglobal.com/corporate-privacy-policy/corporate-privacy-and-cookie-notice',
  entitlementsServerside: '/entitlements-serverside', // Test URL
  addEntitlements: '/add-entitlements',
  deleteEntitlements: '/delete-entitlements',
  reports: '/reports',
  // FEATURE DISABLED (Release july-2026)
  // usageAnalysis: '/usage-analysis',
  exportUsers: '/export-users',
  exportEntitlements: '/export-entitlements',
  productEntitlements: '/product-entitlements',
  userLocation: '/user-location',
  userDashboard: '/user-dashboard',
  details_Id: '/details/:id',
  changeHistory: '/change-history',
  emailDomainContractSettings: '/email-domain-contract-settings',
  manageEmailDomains: '/manage-email-domains',
  contractSettings: '/contract-settings',
  userGroup: '/user-group',
  adminDashboard: '/admin-dashboard',
  analyticsDashboard: '/analytics-dashboard',
  logout: '/logout',
  endUserRegistration: '/user-registration/:id',
  endUserRegistrationSuccess: '/user-registration-success',
  invalidRegistrationLink: '/invalid-registration-link',
  mySubscription: '/my-subscription',
  manageUserIDs: '/manage-user-ids',
  home: '/home',
  // FEATURE DISABLED (Release july-2026)
  // accountTypeSelection: '/account-type-selection',
};

export const Verbiage = {
  noData: 'No Data Available',
  locations: 'No locations in this contract',
  users: 'No users in this contract',
  userGroups: 'No groups in this contract',
  entitlements: 'No entitlements in this contract',
  entitlementsAdded: 'Entitlements Added',
  retriggerSuccess: 'Email sent',
  singleUser: ' user',
  multipleUser: ' users',
  singleUserEntitlement: ' user entitlement',
  multipleUserEntitlement: ' user entitlements',
  noValidDataForUserEntitlementUpload: 'No valid records to be uploaded',
  tileDisabledTooltip:
    'Currently not subscribed, please contact CI support for further assistance',
  commonEntitlementsSave: 'Your entitlements have been saved',
  restrictedEntitlementsAdded:
    'Your entitlements are pending approval with the Contract Admin',
  unrestrictedEntitlementsAdded: 'Your Entitlements will be activated soon',
  mixedEntitlementsAdded:
    'Some of your entitlements will be activated soon, and some are pending approval from the Contract Admin',
  endUserDetailsEdited: 'Your details have been updated',
  disallowedEmailDomain:
    'The user cannot be added as the email domain is invalid for this account',
  emailSent: 'Email invites successfully sent out to the specified Users',
  reachOutToContractAdminToUpdateEntitlements:
    'Please reach out to the contract admin to update your entitlements.',
  contractNotSelected: 'Please select valid contract to download the template.',
  duplicateAddressFound:
    'We have detected existing locations (listed below) that may be duplicate of the new location being added. Please review these locations and ensure that you are not adding a duplicate one. Click on Save if the new location is not a duplicate else click Cancel',
  groupEntitlementsAttemptedUpdate:
    'You have selected users that have been added to a group. Entitlements for such users can not be managed separately and must be managed at group level.',
  displayOptionContractDescriptionFailed:
    'You can set Display option as Contract Description only if description is specified for all contracts. Click on Contract ID to add description.',
  displayOptionContractIDAndDescription:
    'There are at least one or more contracts without a description and will therefore be displayed with Contract ID only. Click on Contract ID below to add a description.',
  resetDisplayOption:
    'Removing description for any contract will update your Display options to "Contract ID" only. Click Ok if you want to proceed deleting the contract description and change display option to "Contract ID". Click Cancel to retain the description and Display Option as "Contract Description"',
  filterCriteriaTooltip:
    'Select criteria below and click on Apply to preview and export. Please note that Email Preferences and other packages can not be filtered simultaneously in the same report',
  noGroupEntitlementsFound:
    'This group has no Entitlements. You can add entitlements by selecting packages and delivery platforms from the above dropdowns or you can use the clone option above to copy Entitlements from another group.',
  noGroupEmailPreferenceFound:
    'This group has no Entitlements. You can add entitlements by selecting desired options in above dropdown(s) or you can use the clone option to copy Entitlements from another group.',
  // FEATURE DISABLED (Release july-2026)
  // userRegistrationGroupAddPartial:
  //   'The user was created successfully but could not be added to the group.',
  lmeEntitlementsGovernanceFailed:
    'The added entitlements exceed the permitted license limit.',
  // Contract Setting Page
  mixedContractStatusWarning:
    'You have selected both onboarded and non-onboarded contracts. Please select only onboarded/non-onboarded contract/s to perform this action.',
  suspendedContractWarning:
    'The contract is suspended. Please reach out to CI Support for further guidance.',
  invalidRegistrationLink:
    'Registration is currently unavailable. Please contact your Administrator.',
  invalidRegistrationLinkDefault: '404 - Invalid Registration Link',
  changeHistoryDownloadExceedMsg:
    'You can only select <configured_value> contracts to download Change History',
};

export const ReduxAction = {
  userInfoSet: 'STORE_USERINFO',
  userContractsSet: 'STORE_USERCONTRACTS',
  selectedEntitlementUser: 'ENTITLEMENT_USERS',
  tabType: 'TAB_TYPE',
  userPreferencesSet: 'STORE_USERPREFERENCES',
  updateEntitlement: 'UPDATE_ENTITLEMENT',
  updateProductEntitlement: 'UPDATE_PRODUCT_ENTITLEMENT',
  updateUGEntitlement: 'UPDATE_USER_GROUP_ENTITLEMENT',
  updateUGProductEntitlement: 'UPDATE_USER_GROUP_PRODUCT_ENTITLEMENT',
  updateUGManageUser: 'UPDATE_USER_GROUP_MANAGE_USERS',
  updateUG_API_Flag: 'UPDATE_USER_GROUP_API_SUCCESS_FLAG',
  distributorsDetail: 'SET_DISTRIBUTORS',
  datasets: 'SET_DATASETS',
  distributors: 'SET_USER_DISTRIBUTORS',
  jobFuncDesignation: 'SET_JOB_DESIGNATION',
  entitlementStatus: 'SET_ENTITLEMENT_STATUS',
  // Location Tab
  countryStateList: 'COUNTRY_STATE_LIST',
  locationTransferSaved: 'LOCATION_TRANSFER_SAVED',
  // DB Config
  dbConfig: 'DB_CONFIG',
  // FEATURE DISABLED (Release july-2026)
  // activePersonaApplied: 'ACTIVE_PERSONA_APPLIED',
};

export const PersistReduxAction = {
  csaActionData: 'CSA_ACTION_INFO',
  // FEATURE DISABLED (Release july-2026)
  // setActivePersona: 'SET_ACTIVE_PERSONA',
  // clearActivePersona: 'CLEAR_ACTIVE_PERSONA',
};

export const ContractDisplayOptions = [
  {
    contractDisplayOptionLabel: 'Contract ID',
    contractDisplayOption: 'ContractNumber',
  },
  {
    contractDisplayOptionLabel: 'Contract Description',
    contractDisplayOption: 'ContractDescription',
  },
  {
    contractDisplayOptionLabel: 'Contract ID and Description',
    contractDisplayOption: 'ContractNumberDescription',
  },
];

export const DeactivationStatuses = {
  onHold: 'On Hold',
  rejected: 'Rejected',
  approved: 'Approved',
};

export const JobTitleCollection = [
  'Acct/Back Office/Settlement',
  'Academic',
  'Administration',
  'Analyst',
  'Broker',
  'Compliance',
  'Consultant',
  'Economist',
  'Engineer',
  'Finance',
  'Executive',
  'Forecasting',
  'Government',
  'IT',
  'Journalist',
  'Legal',
  'Librarian',
  'Marketer',
  'Market Research',
  'Operations Management',
  'Project Management',
  'Publishing',
  'Procurement/Purchasing',
  'Research and Development',
  'Sales/Business Development',
  'Strategic Planning',
  'Student',
  'Trader',
];

export const GenericError = {
  somethingWentWrong: 'Something went wrong. Try again',
};
export const GenericSuccess = {
  feedbackSubmitted: 'Feedback submitted!',
  trainingRequestSubmitted: 'Training Request Submitted!',
};

export const mail = {
  mail_to_address: 'ci.support@spglobal.com',
  mail_from_address: 'donotreply@spglobal.com',
};

export const loaderStyle = {
  width: '100%',
  height: '100%',
  background: '#cdcecf6e',
  display: 'flex',
  position: 'absolute',
  zIndex: '1100',
  justifyContent: 'center',
  alignItems: 'center',
};

export const addressValidation = {
  status: {
    valid: 'Valid',
    inValid: 'InValid',
    partial: 'Partial',
  },
  msg: {
    valid: 'Location Validated Successfully',
    inValid: 'Validation failed',
    partial: 'Validation partially failed',
  },
};

export const queryParamFields = {
  contractPackagesAPIFields:
    'packageId,packageName,distributor,distributorId,distributorPlatform,distributorDisplayName,distributorPlatformDisplayName,deliveryType,productComponentId,platformCategories,userIdFormat',
};

export const ManageEmailAlerts = {
  url: 'https://energy.spglobal.com/plattsemailalerts',
  linkText: 'Energy Preference Center',
  plainText: ' (Click here to manage your email alerts)',
  text: 'Energy Preference Center (Click here to manage your email alerts)',
};
